"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const debug_1 = __importDefault(require("debug"));
const result_1 = require("../../utils/result");
const axios_1 = __importDefault(require("axios"));
const error_handling_queue_1 = require("../../error-handling-queue");
const random_error_generator_1 = require("../../random-error-generator");
const join_url_1 = require("../../utils/join-url");
const debug = debug_1.default('fetch-service');
const ENABLE_RANDOM_ERROR = false;
class FetchService {
    constructor(errorReporting) {
        this.errorReporting = errorReporting;
        this.errorHandlingQueue = new error_handling_queue_1.ErrorHandlingQueue((command) => this.executeCommand(command), (error, originalCommand) => this.errorHandler(error, originalCommand), errorReporting, 'fetch-queue');
        if (ENABLE_RANDOM_ERROR) {
            const possibleErrors = [
                { type: 'network-error' },
                { type: 'client-error', statusCode: 401, statusText: 'Unauthorized', url: 'url' },
                { type: 'client-error', statusCode: 404, statusText: 'Not found', url: 'url' },
                { type: 'server-error', statusCode: 500, statusText: 'Internal server error', url: 'url' },
                { type: 'unknown-response-error', statusCode: 999, statusText: 'Unknown server error', url: 'url' }
            ];
            this.randomErrorGenerator = new random_error_generator_1.RandomErrorGenerator(possibleErrors, {
                randomErrorProbability: 0.4,
                randomErrorLengthMs: { min: 500, max: 10000 }
            });
        }
    }
    start(baseUrl, retryStrategy) {
        debug('start', baseUrl);
        this.baseUrl = baseUrl;
        this.errorHandlingQueue.start(retryStrategy);
    }
    get notifications() {
        return this.errorHandlingQueue.notifications;
    }
    async stop(options) {
        debug('finish');
        await this.errorHandlingQueue.finish({ cancel: options.cancel });
        this.baseUrl = undefined;
    }
    async query(url, cancelToken, responseType, headers) {
        if (this.baseUrl === undefined) {
            throw new Error('Coding error: start not called');
        }
        const fullUrl = join_url_1.joinUrl(this.baseUrl, url);
        debug('query', url, 'full url', fullUrl);
        const result = await this.errorHandlingQueue.queueAndWait({
            type: 'get',
            responseType: responseType,
            url: fullUrl,
            headers: headers
        }, cancelToken);
        if (result.success) {
            switch (responseType) {
                case 'text':
                    return result_1.ok(result.value);
                case 'arraybuffer':
                    return result_1.ok(result.value);
                default:
                    throw new Error(`Coding error: Invalid response type: ${responseType}`);
            }
        }
        return result_1.err(result.error);
    }
    async executeCommand(command) {
        debug('executeCommand', command.type, command.url, command.responseType);
        switch (command.type) {
            case 'get':
                const result = await this.get(command.url, command.responseType, command.headers);
                debug('executeCommand result', result);
                return result;
        }
    }
    async get(url, responseType, headers) {
        if (this.randomErrorGenerator) {
            const error = this.randomErrorGenerator.generate();
            if (error !== false) {
                debug('generated random error', error);
                return result_1.err({ ...error, url });
            }
        }
        try {
            const result = await axios_1.default.get(url, { headers, responseType });
            return result_1.ok(result.data);
        }
        catch (exception) {
            const axiosError = exception;
            debug('axios error', {
                isAxiosError: axiosError.isAxiosError,
                message: axiosError.message,
                code: axiosError.code,
            });
            if (axiosError.response) {
                const response = axiosError.response;
                const common = {
                    statusCode: response.status,
                    statusText: response.statusText
                };
                debug('common error info', common);
                if (response.status >= 400 && response.status < 500) {
                    return result_1.err({ type: 'client-error', ...common, url });
                }
                if (response.status >= 500 && response.status < 600) {
                    return result_1.err({ type: 'server-error', ...common, url });
                }
                return result_1.err({ type: 'unknown-response-error', ...common, url });
            }
            else if (this.isNetworkError(axiosError)) {
                return result_1.err({ type: 'network-error' });
            }
            else {
                console.error(axiosError);
                throw new Error(axiosError.message);
            }
        }
    }
    isNetworkError(error) {
        return error.isAxiosError && !error.response;
    }
    errorHandler(error, originalCommand) {
        debug('errorHandler', error, originalCommand);
        if (error instanceof Error) {
            return {
                type: 'skip'
            };
        }
        switch (error.type) {
            case 'client-error':
            case 'server-error':
            case 'unknown-response-error':
            case 'network-error':
                return { type: 'retry' };
        }
    }
}
exports.FetchService = FetchService;
//# sourceMappingURL=fetch-service.js.map